import React from 'react';

export const acquirerColor = name => {
  const value = (name || '').toLowerCase();
  if (/rede|ita[uú]/.test(value)) return '#d6a16c';
  if (/stone|sicredi|vero|celular|tablet|android/.test(value)) return '#79b3a0';
  if (/windows/.test(value)) return '#95a8ce';
  return '#8caabe';
};

export default function AcquirerIdentity({ name = 'Não informada' }) {
  const value = name.toLowerCase();
  const brands = [
    ['rede', 'rede.png'], ['itaú', 'rede.png'], ['itau', 'rede.png'],
    ['cielo', 'cielo.svg'], ['stone', 'stone.png'], ['getnet', 'getnet.jpg'],
    ['pagbank', 'pagbank.png'], ['pagseguro', 'pagbank.png'], ['sicredi', 'sicredi.png'],
    ['vero', 'vero.jpg'], ['bin', 'bin.png'], ['caixa', 'caixa.jpg'],
    ['clover', 'clover.png'], ['picpay', 'picpay.png']
  ];
  const brand = brands.find(([key]) => value.includes(key));
  return <span className="acquirer-identity">
    <span className="acquirer-icon" aria-hidden="true">
      {brand ? <img src={`/images/acq-${brand[1]}`} alt="" /> :
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          {/celular|tablet|android/.test(value) ? <><rect x="7" y="2" width="10" height="20" rx="2.5"/><path d="M11 18h2M10 5h4"/></> :
            /windows|desktop|computador/.test(value) ? <><rect x="3" y="4" width="18" height="12" rx="2"/><path d="M8 21h8M12 16v5M7 8h4v4H7zM13 8h4v4h-4z"/></> :
              /pos|terminal/.test(value) ? <><rect x="6" y="2" width="12" height="20" rx="3"/><path d="M9 6h6v5H9zM9 15h1m4 0h1m-6 3h1m4 0h1"/></> :
                <><rect x="4" y="4" width="16" height="16" rx="5"/><path d="M10 9a2 2 0 1 1 3 1.7c-.8.4-1 1-1 1.8M12 16h.01"/></>}
        </svg>}
    </span>
    <span>{name || 'Não informada'}</span>
  </span>;
}
